import type { IconData } from '@stacksjs/iconify-core'

export const arrowUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 352L311 41l311 311l-66 65l-245-245L65 417z\"/>",
  "width": 630,
  "height": 700,
  "viewBox": "0 0 630 700"
}

export default arrowUp
